export default "__VITE_ASSET__C9vBsMrc__"